<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.text-xs.no-underline.primary--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .text-xs.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container
    v-tabs.import-tabs(v-model="currentTab")
      v-tabs-slider
      v-tab
        v-icon.mr-4(color="success" v-if="currentTab > 0") $yzi-check-circle
        .text-sm.text-none.font-medium 1. Upload CSV
      v-tab(:class="{ 'tab-disabled': currentTab < 1 }")
        v-icon.mr-4(color="success" v-if="currentTab > 1") $yzi-check-circle
        .text-sm.text-none.font-medium 2. Map Fields
      v-tab(:class="{ 'tab-disabled': currentTab < 2 }")
        .text-sm.text-none.font-medium 3. Review
    v-divider
    v-tabs-items.pb-16(v-model="currentTab")
      v-tab-item.text-md
        .text-xl.font-semibold.mt-8.mb-4 Upload CSV
        div Make sure to read the guidelines before proceeding
        v-card.mt-8.pa-6(outlined)
          v-card.pa-3.mb-8(color="#FFFAE6" flat)
            .text-lg.font-semibold.mb-4 Guidelines
            ol
              li.mb-2 The field Yezza requires are Name and Phone. Other fields are optional, but may be necessary for personalization, segmentation, or other features.
              li Clearly label each column in your import file so you can easily choose the field type during the import process. For example, if you have a column named "Contact Email Addresses," you'll know to choose the Email Address field type.
          .neutral500--text
            div Make sure your file is in .csv format.
            div If customer already exists, customer data will be updated
          v-row
            v-col(cols="12" md="6" sm="8")
              .d-flex.mt-4.align-center
                v-file-input.round-2xl(v-model="inputFile" outlined show-size accept=".csv" prepend-icon placeholder="Choose a file" hide-details)
                v-btn.ml-2.button-Aa-large.px-6.round-lg(height=48 depressed color="#EEEEEE" @click="browseFile") {{ $t('browse') }}
                input.d-none(type="file" accept=".csv" @change="onIncomeFileChange" ref="uploadInput")
          .mt-8 
            v-btn.button-md.white--text(@click="continueUpload" color="info500" depressed :loading="isUploading" :disabled="!inputFile" height=48) Continue
      v-tab-item
        template(v-if="mappingResponse && inputFile")
          map-fields(:data="mappingResponse" :inputFile="inputFile" @onValidate="onValidate" @onMapping="onMapping")
      v-tab-item
        review-import(:data="validateResponse" :inputFile="inputFile" :mapperFormData="mapperFormData" @onReupload="onReupload")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ReviewImport from '@/components/clinic/patient/ReviewImport.vue'
import MapFields from '@/components/clinic/patient/MapFields.vue'

export default {
  components: { 
    ReviewImport,
    MapFields
  },
  data: () => ({
    currentTab: 0,
    breadcrumbItems: [
      {
        text: 'Patient',
        disabled: false,
        href: '/admin/clinic/patient'
      },
      {
        text: 'Import patient from CSV',
        disabled: true
      }
    ],
    inputFile: null,
    isUploading: false,
    mappingResponse: null,
    validateResponse: null,
    mapperFormData: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    onIncomeFileChange(e) {
      this.inputFile = null
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.inputFile = files[0]
    },
    browseFile() {
      this.$refs.uploadInput.click()
    },
    continueUpload() {
      this.isUploading = true
      const params = new FormData()
      params.append('file', this.inputFile)
      this.$axios.post(`/connect/${this.company.slug}/customers/import_csv/mapping`, params)
      .then(resp => {
        this.processMappingResponse(resp.data)
      })
      .catch(e => {
        if (e?.response?.data?.file?.length > 0) {
          this.showMessage(['error', e.response.data.file[0]])
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
        }
      })
      .finally(() => {
        this.isUploading = false
      })
    },
    processMappingResponse(responseData) {
      this.mappingResponse = responseData
      const fields = []
      responseData.default_fields.forEach(item => {
        item.type = "System"
        fields.push(item)
      })
      responseData.custom_fields.forEach(item => {
        item.type = "Custom"
        fields.push(item)
      })
      this.$store.commit('customers/setFields', fields)
      const rowLength = responseData.data[0].length
      if (rowLength <= 1) {
        this.showMessage(['error', 'Row data is empty'])
      } else {
        this.currentTab = 1
      }
    },
    onValidate(response) {
      this.validateResponse = response
      this.currentTab = 2
    },
    onMapping(response) {
      this.mapperFormData = response
    },
    onReupload() {
      this.inputFile = null
      this.currentTab = 0
    }
  }
}
</script>

<style lang="scss">
.import-tabs {
  .v-tabs-slider-wrapper {
    height: 6px !important;
    bottom: -3px !important;
  }

  .v-tabs-slider {
    border-radius: 3px !important;
  }
}
</style>